module.exports = __webpack_public_path__ + "media/mondstadt_starlit.46440156.mp3";